import { render, staticRenderFns } from "./ImportClassifierDlg.vue?vue&type=template&id=54e44282"
import script from "./ImportClassifierDlg.vue?vue&type=script&lang=js"
export * from "./ImportClassifierDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports